const toSearchCriteria = (filterFields) => {
    const typeFilterMap = {};
    filterFields.forEach((filter) => {
        let type = typeFilterMap[filter.typeId];
        if (!type) {
            type = { type: filter.type, categories: [] };
        }
        type.categories = filter.fields.map((field) => ({
            id: field.fieldExtId,
            values: field.values,
        }));
        typeFilterMap[filter.typeId] = type;
    });
    return Object.values(typeFilterMap);
};

/* Returns a list of objects:
{
    "type": {
        "class": "typename",
        "extid": "room",
        "id": 4,
        "name": "Lokal"
    },
    "categories": [
        {
            "id": "room.equipment",
            "values": [
                "Mikrofon, 5 st"
            ]
        }
    ]
}
*/
/** One type's filter, as the external object search expects it. */
type TSearchCriteriaType = {
    type: { class: "typename"; extid: string };
    categories: { id: number; values: string[] }[];
};

const toSearchCriteriaFromObjects = (filterObjects): TSearchCriteriaType[] => {
    const typeFilterMap: Record<string, TSearchCriteriaType> = {};
    filterObjects.forEach((filter) => {
        let type = typeFilterMap[filter.extId];
        if (!type) {
            type = { type: { class: "typename", extid: filter.extId }, categories: [] };
        }
        type.categories = filter.value.categories.map((field) => ({
            id: field.id,
            values: field.values,
        }));
        typeFilterMap[filter.extId] = type;
    });
    return Object.values(typeFilterMap);
};

export type TExternalSearchCriteria = {
    type: string;
    categories: { id: string; values: string[] }[];
    searchString?: string;
};

type TObjectFilterInput = {
    typeExtId: string;
    categories: { fieldExtId: string; values: string[] }[];
    searchString?: string;
};

/** An activity's object filter as search criteria for the object list. */
const objectFilterToSearchCriteria = ({
    typeExtId,
    categories,
    searchString,
}: TObjectFilterInput): TExternalSearchCriteria => ({
    type: typeExtId,
    categories: categories.map(({ fieldExtId, values }) => ({ id: fieldExtId, values })),
    searchString,
});

export { toSearchCriteria, toSearchCriteriaFromObjects, objectFilterToSearchCriteria };
